import classNames from 'classnames';
import { FC } from 'react';

type Props = {};

export const ReasonImage: FC<Props> = ({ children }) => {
	const classes = classNames('b-reason__image');
	return <div className={classes}>{children}</div>;
};
